import { render } from "./VideoLinkInput.vue?vue&type=template&id=384f8641&scoped=true&ts=true"
import script from "./VideoLinkInput.vue?vue&type=script&lang=ts"
export * from "./VideoLinkInput.vue?vue&type=script&lang=ts"

import "./VideoLinkInput.vue?vue&type=style&index=0&id=384f8641&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384f8641"]])

export default __exports__